import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Map from '@uiw/react-baidu-map-map';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withMap(Comp) {
  return /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(Map, _extends({}, props, {
    children: mapProps => {
      return /*#__PURE__*/_jsx(Comp, _extends({
        ref: ref
      }, props, mapProps));
    }
  })));
}